import request from "sync-request";
import { EnvironmentRegistry } from "./registry/environmentRegistry";
import { configComparatorType, ConfigComparator } from "../types/types";
import _ from "underscore";

// const uatJson = require("../features/configComparator/config/uat.json");
// const prodJson = require("../features/configComparator/config/prod.json");
export function getEnvToken(env: string) : string {
    let token = '';
    if(env) {
        token = EnvironmentRegistry.getToken(env);
    }
    return token;
}

export function getConfigToCompare(env: string, config: string,lob:string) : JSON {
    const url = EnvironmentRegistry.getUrl(env);
    const headers = EnvironmentRegistry.makeAuthHeaders(getEnvToken(env));
    const configRefUrl = EnvironmentRegistry.getConfigRefUrl(config);
    let response = request("GET", `${url}${configRefUrl}?lob=${lob}`, {headers});
    return JSON.parse(response.getBody('utf8'));
}
export function getConfigToCompareInSameEnv(env: string, config: string, token:string, lob:string) : JSON {
    const url = EnvironmentRegistry.getUrl(env);
    const headers = EnvironmentRegistry.makeAuthHeaders(token);
    const configRefUrl = EnvironmentRegistry.getConfigRefUrl(config);
    let response = request("GET", `${url}${configRefUrl}?lob=${lob}`, {headers});
    return JSON.parse(response.getBody('utf8'));
}

function compareConfigFields(obj1:any, obj2:any,selectedEntity:string):boolean{
    let excludedKeys: string[] = EnvironmentRegistry.getExcludedKeys(selectedEntity);
    let result = true;
    result = result && Object.keys(obj1).every((key)=>{
        if(excludedKeys.includes(key)){
            return true;
        }
        return _.isEqual(obj1[key],obj2[key]);
    })
    result = result && Object.keys(obj2).every((key)=>{
        if(excludedKeys.includes(key)){
            return true;
        }
        return _.isEqual(obj1[key],obj2[key]);
    })
    return result;
}

export function compareConfigJson(uniqueAttr:string,configJson: any, env: string, configJsonToCompare: any, envCmp: string, configCompareMap: Map<string, configComparatorType>, selectedEntity:string) : Map<string, configComparatorType> {
    let configFeatureMainArr = configJson.features;
    let configFeatureCompareArr = configJsonToCompare.features;
    const fields = uniqueAttr.split(",");
    let configCompareTempMap = new Map<string, any>(); 
    
    configFeatureCompareArr.forEach((elementToCmp: any): void => { 
        let dynamicUniqueKey = fields.reduce((acc,r)=>acc.concat(String(elementToCmp[r])),[] as string[]).join("-");
        configCompareTempMap.set(dynamicUniqueKey, elementToCmp); 
    });
    configFeatureMainArr.forEach((element: any): void => {
        let dynamicUniqueKey = fields.reduce((acc,r)=>acc.concat(String(element[r])),[] as string[]).join("-");
        let cmpConfig = configCompareMap.get(dynamicUniqueKey);        
        if(cmpConfig == null) {                                     
            cmpConfig = new ConfigComparator(element.id, dynamicUniqueKey, element.description, element.activeStatus, new Map<string, boolean>().set(env, true), new Map<string, JSON>().set(env, element));
            configCompareMap.set(dynamicUniqueKey, cmpConfig);
        }
        let tempCmpConfig = configCompareTempMap.get(dynamicUniqueKey); 
        if(tempCmpConfig != null) {
            if (compareConfigFields(element,tempCmpConfig,selectedEntity)) {
                cmpConfig.cmpDiff.set(envCmp, true);
            } else {
                cmpConfig.cmpDiff.set(envCmp, false);
            }
            cmpConfig.diff.set(envCmp, tempCmpConfig);
            configCompareTempMap.delete(dynamicUniqueKey);
        } else {
            cmpConfig.cmpDiff.set(envCmp, false);
            cmpConfig.diff.set(envCmp, JSON.parse('{}'));
        }
    });
    if(configCompareTempMap.size > 0) {                             
        configCompareTempMap.forEach((element, key) => {
            let dynamicUniqueKey = fields.reduce((acc,r)=>acc.concat(String(element[r])),[] as string[]).join("-");
            let cmpConfig = new ConfigComparator(key, dynamicUniqueKey, element.description, element.activeStatus, new Map<string, boolean>().set(env, false), new Map<string, JSON>().set(env, JSON.parse('{}')));
            cmpConfig.cmpDiff.set(envCmp, true);
            cmpConfig.diff.set(envCmp, element);
            configCompareMap.set(dynamicUniqueKey, cmpConfig);
        });
    }
    return configCompareMap;
}

export function cmpAllEnvs(): configComparatorType[] {
    let configCompareArr: configComparatorType[] = [];
    let jsonOrig = getConfigToCompare("uat", "transformers",localStorage.getItem("lob") as string);
    let jsonCmp = getConfigToCompare("demo", "transformers",localStorage.getItem("demolob") as string);
    let configCompareMap = new Map<string, configComparatorType>();
    let configCompareTempMap = compareConfigJson("name",jsonOrig, "uat", jsonCmp, "demo", configCompareMap, "transformers");
    configCompareArr = Array.from(configCompareTempMap.values());
    return configCompareArr;
}